import { useHistory as useReactRouterHistory } from 'react-router-dom';
import type { LocationDescriptor, Path } from 'history';

import getRelativeUrlStringFromLocation from '../utils/get-relative-url-string-from-location';
import { useNavigation } from '../navigation';

import useWizardEmitNavigateEvent from './use-wizard-emit-navigate-event';
import useGetEmbeddedLocation from './use-get-embedded-location';

const useEmbeddedHistory = () => {
  const history = useReactRouterHistory();
  const emitNavigateEvent = useWizardEmitNavigateEvent();
  const getEmbeddedLocation = useGetEmbeddedLocation();

  const createEmbeddedHistoryMethod = (method: 'push' | 'replace') => (location: Path | LocationDescriptor, state?: any) => {
    const embeddedLocation = getEmbeddedLocation(location);
    const relativeUrl = getRelativeUrlStringFromLocation(location);

    emitNavigateEvent(relativeUrl);

    if (embeddedLocation) {
      history[method](embeddedLocation, state);
    }
  };

  return {
    ...history,
    push: createEmbeddedHistoryMethod('push'),
    replace: createEmbeddedHistoryMethod('replace'),
  };
};

const useHistory = () => {
  const { isEmbedded } = useNavigation();
  const useHistoryHook = isEmbedded ? useEmbeddedHistory : useReactRouterHistory;

  return useHistoryHook();
};

export default useHistory;
